import angular from 'angular';

/**
 * Controla la directiva "contenedor-comentarios"
 */
ContenedorComentariosCtrl.$inject = [];
export default function ContenedorComentariosCtrl() {
    const vm = this;

    let random = "";
    for (let i = 0; i < 6; i++) random += "" + Math.floor(Math.random() * 101);
    const id = "cont-com-inci" + random;
    vm.id = id;

    setTimeout(() => {
        const url = `${Sigo.var.path}/app-vue?random=${random}#/comentarios-contenedor?id=${vm.incidenciaId}&modelo=incidencias&mostrarMenu=false`;
        const doc = document.getElementById(id);
        const iframe = document.createElement("iframe");
        iframe.width = "100%";
        iframe.height = "600px"
        iframe.style.border = 'none';
        iframe.src = url;
        doc.appendChild(iframe);
    }, 100);
}